module.exports = __webpack_public_path__ + "img/business-dinner.0bfa2336.jpg";